export default __webpack_public_path__ + "static/media/trampapo_01-09.e1007894.png";